function ArrowRight(){

    return (
        <div className='ml1 mr1'>
            &rarr;
        </div>
    )
}

export default ArrowRight